<template>
  <!-- Design-system look: the info hint of a tooltip trigger as a solid circle in the info
       colour with a white "i" (the same colour its outline had before). -->
  <span
    class="inline-flex flex-none items-center justify-center rounded-full text-(--ds-color-white)"
    :style="{ width: size, height: size, backgroundColor: color }"
    aria-hidden="true"
    data-test="info-badge"
  >
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.75"
      stroke-linecap="round"
      class="size-full"
    >
      <path d="M12 11.25v5.5" />
      <path d="M12 7.5h.01" />
    </svg>
  </span>
</template>

<script setup>
defineProps({
  /** CSS size of the circle (the old look's icon size). */
  size: {
    type: String,
    default: '14px',
  },
  color: {
    type: String,
    default: 'var(--ds-status-info-text)',
  },
})
</script>
